export enum Origin {
  MEETING_PLATE = "MEETING_PLATE",
  MAX_LINK = "MAX_LINK",
  PLATE_SHARE = "PLATE_SHARE"
}

export enum Source {
  MEETING_PLATE = "MEETING_PLATE",
  EMAIL = "EMAIL",
  MAX_LINK = "MAX_LINK",
  H5_HOMEPAGE = "H5_HOMEPAGE",
  ENTERPRISE_WECHAT_MESSAGE = "ENTERPRISE_WECHAT_MESSAGE"
}

export const h5OriginArr = [
  Origin.MEETING_PLATE,
  Origin.MAX_LINK
]

export const h5SourceArr = [
  Source.MEETING_PLATE,
  Source.EMAIL,
  Source.MAX_LINK,
  Source.H5_HOMEPAGE,
  Source.ENTERPRISE_WECHAT_MESSAGE
];

export const maxMobileWidth = 768;

export enum PermissionChoose {
  Check = "EVERYONE_CAN_VIEW", // 所有人可查看
  Password = "EVERYONE_PASSWORD_CAN_VIEW", // 所有人输入密码可查看
  StaffCheck = "ORG_MEMBER_CAN_VIEW", // 企业内成员可查看
  StaffPassword = "ORG_MEMBER_PASSWORD_CAN_VIEW" // 企业内成员输入密码可查看
}

export enum OSPermissionChoose {
  OrgMember = "orgMember",
  All = "all",
}

export enum RoleType {
  Creator = 'CREATOR',
  Manager = 'MANAGEABLE',
  Viewer = 'VIEWABLE',
  Removed = 'Removed'
}

export const RoleTextMap: { [key: string]: string } = {
  [RoleType.Creator]: '创建人',
  [RoleType.Manager]: '可管理',
  [RoleType.Viewer]: '可查看',
  [RoleType.Removed]: '移除',
}

export const EditableSharePermissionList = [RoleType.Creator, RoleType.Manager];

export enum LinkValidPeriodType {
  Permanent = 'PERMANENT', // 永久
  OneWeek = 'SEVEN_DAY', // 7天
  TwoWeek = 'FOURTEEN_DAY', // 14天
  OneMonth = 'THIRTY_DAY' // 30天
}

export const LinkValidDays: { [key: string]: number } =
{
  [LinkValidPeriodType.Permanent]: -1,
  [LinkValidPeriodType.OneWeek]: 7,
  [LinkValidPeriodType.TwoWeek]: 14,
  [LinkValidPeriodType.OneMonth]: 30,
}

export const LinkValidTextMap: { [key: string]: string } = {
  [LinkValidPeriodType.Permanent]: '永久',
  [LinkValidPeriodType.OneWeek]: '7天',
  [LinkValidPeriodType.TwoWeek]: '14天',
  [LinkValidPeriodType.OneMonth]: '30天',
}

export const PermissionStatusMap: { [key: string]: string } = {
  [PermissionChoose.Check]: '所有人可查看',
  [PermissionChoose.Password]: '所有人输入密码可查看',
  [PermissionChoose.StaffCheck]: '企业内成员可查看',
  [PermissionChoose.StaffPassword]: '企业内成员输入密码可查看',
}

export enum MeetingRecordVisibility {
  orgMember = 'orgMember',
  all = 'all'
}